module.exports = __webpack_public_path__ + "static/media/chef_weida.dec4e0cd.jpg";